import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import '../../App.css';
import '../news/newsWrapp.css';
import axios from 'axios';
import { END_URL, IMG_URL } from "../../config.js";

function NewsWrapp() {
  const [newsData, setNewsData] = useState([]);
  const [featuredNews, setFeaturedNews] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {

    if (location.hash === "#newswrap") {

      setTimeout(() => {
        const el = document.getElementById("newswrap");

        if (el) {
          const yOffset = -150;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 200);

    }

  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${END_URL}news`);
        if (response.data.status && response.data.data) {
          setNewsData(response.data.data);
          setFeaturedNews(response.data.data[0]); // Use first news as featured
        }
      } catch (error) {
        console.error('Error fetching news:', error);
      }
    };
    fetchData();
  }, []);

  // To feature a card on click from sidebar
  const handleFeature = (newsItem) => {
    setFeaturedNews(newsItem);
    setIsExpanded(false);
  };

  const ReadMore = () => {
    setIsExpanded(true);
  }

  return (
    <section className="news-wrapp-new" id="newswrap">
      <div className="container">
        <h2>News & Case Updates</h2>
        <div className="row news-row">
          <div className="col-md-7">
            {featuredNews && (
              <div className="news-featured-card">
                <div className="news-featured-card-image">
                  <img
                    src={`${IMG_URL}/public/${featuredNews.image}`}
                    alt={featuredNews.title || "News Image"}
                  />
                </div>
              <div className="news-featured-card-content">
  <h5>
    {new Date(featuredNews.date).toLocaleString("default", {
      month: "long",
      year: "numeric",
    })}
  </h5>
  <h3>{featuredNews.title}</h3>

  <p>
    {isExpanded
      ? featuredNews.content
      : featuredNews.content.split(" ").slice(0, 10).join(" ") + "..."
    }

    {!isExpanded && featuredNews.content.split(" ").length > 10 && (
      <a className="read-more-btn" onClick={() => ReadMore()} > Read more</a>
    )}
  </p>

  {/* Toggle button: Read More / Read Less */}
  {/* <a
    href="#"
    className="read-more-btn"
    onClick={(e) => {
      e.preventDefault();
      setIsExpanded(!isExpanded);
    }}
  >
    {isExpanded ? "Read Less" : "Read More"}
  </a> */}
</div>

              </div>
            )}
          </div>
          <div className="col-md-5">
            <div className="news-sidebar">
              <h4>All News</h4>
              <div className="news-article-list">
                {newsData.slice(0, 4).map((item) => (
                  <div
                    className={`news-article-item ${featuredNews?.id === item.id ? "active" : ""}`}
                    key={item.id}
                    onClick={() => handleFeature(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <h5>
                      {new Date(item.date).toLocaleString("default", {
                        month: "long",
                        year: "numeric",
                      })}
                    </h5>
                    <p>
                      {item.title.length > 60 ? item.title.slice(0, 60) + "..." : item.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsWrapp;
